// 顶部公告(信息条跑马灯 + 「更多」弹窗)。lottery-go admin 对接。
// request.js 已注入前缀 /api/v1/admin + Bearer;拦截器解包 {code,data,msg}。
import request from './request'

// GET /notice/list -> { list: [{ id, title, content, notice_type, created_at }], total }
//   后端只返回房间弹窗(notice_type=2)/平台系统公告(notice_type=3);无则回退全部。
//   统一收敛成数组返回,页面直接消费 list。
//   dev 房 888888 无公告 → 返回 [],页面保留兜底文案(TODO: 运营环境验证真数据)。
export function fetchAdminNotices() {
  return request({ url: '/notice/list', method: 'get' }).then((d) => (d && Array.isArray(d.list) ? d.list : []))
}
